import React, { Component } from "react";
import { connect } from "react-redux";

import { createUser } from "actions/user";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/User/Form";

class UserCreate extends Component {
  handleFormSubmit = data => {
    this.createUser(data);
  };

  createUser(data) {
    const { toggleNotification, toggleFullPageSpinner, createUser, history } = this.props;
    toggleFullPageSpinner(true);
    createUser(data)
      .then(() => {
        toggleNotification(true, { message: "Created User Success", infoClassName: "is-success" });
        history.push(`/users`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return <Form handleFormSubmit={this.handleFormSubmit} />;
  }
}

export default connect(
  null,
  {
    createUser,
    toggleFullPageSpinner,
    toggleNotification
  }
)(UserCreate);



// WEBPACK FOOTER //
// ./src/pages/User/Create/index.js